<template>
  <div>
    <action-alert :type="alert.type" :is-visible="alert.isVisible">{{alert.text}}</action-alert>
    <div
      class="card m-b-0"
      :style="{
        borderBottom: depth > 0 ? 'none' : '',
        borderLeft: depth > 0 ? 'none' : '',
        borderRight: depth > 0 ? 'none' : '',
      }"
    >
      <div
        class="card-header"
        style="cursor: pointer"
        id="headingOne"
        role="tab"
        @click="changeToggle"
      >
        <div class="d-flex flex-row align-items-center justify-content-between">
          <div class="d-flex">
            <h6 class="mb-0" :style="{ marginLeft: `${20 * depth}px` }">
              <a class="collapsed d-flex align-items-center">
                <img
                  class="folder-icon mr-2"
                  :src="
                    !toggled
                      ? 'https://img.icons8.com/material/24/000000/opened-folder.png'
                      : 'https://img.icons8.com/metro/26/000000/opened-folder.png'
                  "
                />
                {{ title || structure.name }}
              </a>
            </h6>
          </div>
          <div class="d-flex align-items-center ml-2" style="height: 40px">
            <span
              v-if="
                fileUpload &&
                fileUpload.status &&
                fileUpload.status !== 'selected'
              "
              class="ml-2"
            >
              <el-tooltip
                v-if="fileUpload.status === 'failed'"
                effect="dark"
                placement="top"
                :content="fileUpload.high_msg || 'Upload failed'"
              >
                <font-awesome-icon
                  size="lg"
                  :color="getAlertIconColor(fileUpload.status)"
                  :icon="getAlertIcon(fileUpload.status)"
                />
              </el-tooltip>
              <font-awesome-icon
                v-else
                size="lg"
                :color="getAlertIconColor(fileUpload.status)"
                :icon="getAlertIcon(fileUpload.status)"
              ></font-awesome-icon>
            </span>
            <span
              v-if="fileUpload && fileUpload.status === 'selected'"
              class="ml-2"
              style="line-height: 40px"
            >
              Confirm uploading new file
              {{ `${fileUpload.fileName} (new)` }}</span
            >
          </div>
          <div
            v-if="structure.errors && structure.errors.length"
            class="d-flex align-items-center justify-content-center"
          >
            <div class="w-100 mt-1 align-items-center justify-content-center text-center">
              <font-awesome-icon
                class="warning-icon"
                icon="exclamation-triangle"
              />
              <span v-if="structure.errors.length">
                ( {{ structure.errors.length }} )
              </span>
            </div>
          </div>
          <div
            class="mr-4 d-flex align-items-center justify-content-center"
            style="width: 100px"
          >
            <el-upload
              v-if="!title && !useCustoms"
              class="upload-file"
              :ref="`upload`"
              :show-file-list="false"
              :headers="{ Authorization: authToken }"
              :data="{ foldertype: structure.name }"
              :on-change="(f, flist) =>handleChange(f)"
              :on-success="(res) => handleSuccess(res)"
              :on-error="(err) => handleError(err)"
              :action="`${baseUrl}/study/${id}/upload`"
              :auto-upload="false"
            >
              <el-button
                :disabled="uploadDisabled"
                :class="{
                  'upload-button': true,
                  visible: !fileUpload || fileUpload.status !== 'selected',
                }"
                slot="trigger"
                size="small"
                type="primary"
                >
                Upload
              </el-button
              >
              <el-button
                :class="{
                  'upload-button': true,
                  visible: fileUpload && fileUpload.status === 'selected',
                }"
                class="mt-1 ml-3"
                size="small"
                type="success"
                @click.stop="useCustoms ? customUpload() : submitUpload()"
                >Confirm</el-button
              >
              <el-button
                :class="{
                  'upload-button': true,
                  visible: fileUpload && fileUpload.status === 'selected',
                }"
                class="mt-1 ml-3"
                size="small"
                type="warning"
                @click.stop="useCustoms ? customCancelUpload() : cancelUpload()"
                >Cancel</el-button
              >
            </el-upload>
          </div>
        </div>
      </div>

      <div
        class="collapse"
        :class="toggled ? 'show' : 'hide'"
        id="collapseOne"
        role="tabpanel"
        aria-labelledby="headingOne"
        data-parent="#accordion"
        style=""
      >
        <div class="card-body p-0">
          <div v-if="structure.type === 'directory'">
            <ErrorDetailsTable
              v-if="structure.errors && !structure.hideDetails"
              class="mt-3"
              :errors="structure.errors"
            />
            <div v-for="obj in children" :key="obj.name">
              <div v-if="obj.type === 'directory'">
                <Folder
                  :depth="depth + 1"
                  :structure="obj"
                  @refresh="emitRefresh"
                  :show-files-version-control-button="showFilesVersionControlButton"
                  :use-customs="useCustoms"
                  @custom-download="customDownload"
                  @custom-cancel-upload="customCancelUpload"
                  @custom-upload="customUpload"
                  @custom-on-change="customOnChange"
                  @set-old-file="setOldFile"
                >
                </Folder>
              </div>
              <FileList
                v-else
                :file="obj"
                :depth="depth + 1"
                :folder-type="structure.name"
                :show-version-control-button="showFilesVersionControlButton"
                :use-customs="useCustoms"
                @refresh="emitRefresh"
                @custom-download="customDownload"
                @custom-cancel-upload="customCancelUpload"
                @custom-upload="customUpload"
                @custom-on-change="customOnChange"
                @set-old-file="setOldFile"
              ></FileList>
            </div>
          </div>
          <FileList
              v-else
              :file="structure"
              :depth="depth + 1"
              :show-version-control-button="showFilesVersionControlButton"
              :use-customs="useCustoms"
              @custom-download="customDownload"
              @custom-cancel-upload="customCancelUpload"
              @custom-upload="customUpload"
              @custom-on-change="customOnChange"
              @set-old-file="setOldFile"
          >
          </FileList>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import studyActions from '../../store/modules/studies/actionTypes'
import FileList from './FileList'
import ActionAlert from '../shared/ActionAlert'
import ErrorDetailsTable from '@/components/FileStructure/ErrorDetailsTable'

export default {
  name: 'Folder',
  components: { FileList, ActionAlert, ErrorDetailsTable },
  props: {
    depth: Number,
    structure: Object,
    title: String,
    showFilesVersionControlButton: {
      type: Boolean,
      default: true
    },
    useCustoms: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      toggled: false,
      baseUrl: process.env.VUE_APP_API_BASE_URL,
      id: this.$route.params.id,
      authToken: window.localStorage.getItem('auth_token_default'),
      uploadInterval: null,
      fileUpload: null,
      file: {},
      uploadDisabled: false,
      alert: {
        isVisible: false,
        type: '',
        icon: '',
        text: ''
      }
    }
  },
  computed: {
    children () {
      return (this.structure.children || [])
        .slice()
        .sort((a, b) => (a.name > b.name ? 1 : b.name > a.name ? -1 : 0))
    }
  },
  methods: {
    ...mapActions({
      getFileUploadJobStatus: studyActions.CHECK_STUDY_FILE_UPLOAD_STATUS
    }),
    changeToggle () {
      this.toggled = !this.toggled
    },
    handleChange (file) {
      switch (file.status) {
        case 'ready':
          this.fileUpload = {
            fileName: file.name,
            status: 'selected'
          }
          if (this.useCustoms) this.customOnChange(file)
          break
        case 'fail':
          this.fileUpload = {
            fileName: file.name,
            status: 'failed'
          }
          if (this.useCustoms) this.customOnChange(file)
          break
        default:
          console.log(file.status)
      }
    },
    handleSuccess (res) {
      if (res === 'success') {
        this.uploadDisabled = false
        this.emitRefresh()
      } else if (!res || res === 'No such job') {
        this.fileUpload = {
          high_msg: 'Upload failed',
          status: 'failed'
        }
        this.uploadDisabled = false
      } else {
        try {
          this.uploadInterval = setInterval(async () => {
            const data = await this.getFileUploadJobStatus({
              jobId: res,
              studyId: this.id
            })
            if (data && data.status) {
              this.fileUpload = data
              if (['finished', 'failed'].includes(data.status)) {
                clearInterval(this.uploadInterval)
                this.uploadDisabled = false
                this.emitRefresh()
              }
            }
          }, 2000)
        } catch {
          clearInterval(this.uploadInterval)
          this.uploadDisabled = false
        }
      }
    },
    handleError (err) {
      this.toggleAlert(
        'warning',
        'el-icon-circle-check',
        JSON.parse(err.message).message
      )
    },
    toggleAlert (type, icon, text) {
      this.alert = {
        type,
        icon,
        text,
        isVisible: true
      }
      setTimeout(() => this.alert.isVisible = false, 5000)
    },
    getAlertIcon (status) {
      switch (status) {
        case 'queued':
          return 'pause-circle'
        case 'started':
          return 'circle-notch'
        case 'failed':
          return 'times-circle'
        case 'finished':
          return 'check-circle'
        default:
          return ''
      }
    },
    getAlertIconColor (status) {
      switch (status) {
        case 'queued':
          return '#DA7B11'
        case 'started':
          return '#2D5897'
        case 'failed':
          return '#CE462E'
        case 'finished':
          return '#187240'
        default:
          return '#444444'
      }
    },
    submitUpload () {
      this.uploadDisabled = true
      const refName = `upload`
      this.$refs[refName].submit()
      this.fileUpload = null
    },
    cancelUpload () {
      const refName = `upload`
      this.$refs[refName].clearFiles()
      this.fileUpload = null
    },
    emitRefresh () {
      this.$emit('refresh')
    },
    async customDownload (f) {
      await this.$emit('custom-download', f)
    },
    customCancelUpload () {
      this.$emit('custom-cancel-upload')
      this.fileUpload = null
    },
    async customUpload () {
      this.uploadDisabled = true
      await this.$emit('custom-upload')
      this.fileUpload = null
    },
    customOnChange (f) {
      this.$emit('custom-on-change', f)
    },
    setOldFile (f) {
      this.$emit('set-old-file', f)
    }
  }
}
</script>

<style scoped lang="scss">
@import '../../assets/scss/variables';
.folder-icon {
  width: 15px;
  height: 15px;
}

.upload-button {
  display: none;
}

.upload-button.visible {
  display: unset;
}
.warning-icon {
  font-size: 15px;
  color: $red-600;
}
.show-details-button {
  font-size: 12px;
  background-color: #409EFF;
  color: #fff;
  border-radius: .3rem;
  border: 1px solid #409EFF;
  padding: .5rem 1rem;
  &:hover {
    background-color: #66b1ff;
    border: 1px solid #66b1ff;
  }
}
</style>
